<template>
  <v-container grid-list-xl text-xs-center>
    <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
    <notifications group="my-services" key="my-services" />

    <v-layout row wrap v-if="!data.initial">
      <v-flex xs12 class="text-xs-left">
        <v-btn
          dark
          color="blue darken-3"
          @click="helpDialog.general = true"
        >
          <v-icon dark left>help</v-icon> Hjelp
        </v-btn>
      </v-flex>
      <v-flex xs12 md6 v-if="data.email.enabled">
        <v-card color="blue-grey darken-3" class="white--text">
          <v-card-title primary-title>
            <v-spacer />
            <div class="headline">
              E-postkontoer
              <v-btn icon flat dark @click="helpDialog.email = true">
                <v-icon>help</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card-text>
            <p><strong>Legg til og endre e-postkontoer, videresendinger og aliaser.</strong></p>
            <p>
              Du har <strong>{{ data.email.emails.length }}</strong> e-postkonto{{ data.email.emails.length|pluralize('er') }} og <strong>{{ data.email.forwards.length }}</strong> videresending{{ data.email.forwards.length|pluralize('er') }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="cyan darken-3" dark :to="{ name: 'email-list' }">Administrer</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 v-if="data.webhotel.enabled">
        <v-card color="blue-grey darken-3" class="white--text">
          <v-card-title primary-title>
            <v-spacer />
            <div class="headline">
              Webhotell
              <v-btn icon flat dark @click="helpDialog.webhotel = true">
                <v-icon>help</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card-text>
            <p><strong>Finn ftp-info, sett nytt passord og passordbeskytt områder.</strong></p>
            <p>Du har <strong>{{ data.webhotel.domains.length }}</strong> webhotell</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="cyan darken-3" dark :to="{ name: 'webhotel-list' }">Administrer</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 v-if="data.mekke.enabled">
        <v-card color="blue-grey darken-3" class="white--text">
          <v-card-title primary-title>
            <v-spacer />
            <div class="headline">
              Mekke Publisering
              <v-btn icon flat dark @click="helpDialog.mekke = true">
                <v-icon>help</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card-text>
            <p><strong>Finn brukernavn og sett nytt passord.</strong></p>
            <p>Du har <strong>{{ data.mekke.domains.length }}</strong> Mekke Publisering bruker{{ data.mekke.domains.length|pluralize('e') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="cyan darken-3" dark :to="{ name: 'mekke-list' }">Administrer</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 v-if="data.domain.enabled">
        <v-card color="blue-grey darken-3" class="white--text">
          <v-card-title primary-title>
            <v-spacer />
            <div class="headline">
              Domener
              <v-btn icon flat dark @click="helpDialog.dns = true">
                <v-icon>help</v-icon>
              </v-btn>
            </div>
            <v-spacer />
          </v-card-title>
          <v-card-text>
            <p><strong>Endre i DNS (navneserver) for ditt domenenavn.</strong></p>
            <p>Du har <strong>{{ data.domain.domains.length }}</strong> domene{{ data.domain.domains.length|pluralize('r') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="cyan darken-3" dark :to="{ name: 'domain-list' }">Administrer</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="helpDialog.general" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Hjelp
        </v-card-title>
        <v-card-text>
          <p>
            Her på Min Side kan du selv enkelt gjøre endringer for dine tjenester hos {{ config.NAME }}.<br />
            Noen ting er uproblematisk å gjøre selv, slik som å endre passord og adresseinfo, men her kan du også slette e-postadresser og nettsider som er mer kritisk. Selv om vi har backup, er det bedre å spørre en gang for mye enn for lite for å slippe ekstra kostnader. Kontakt oss gjerne på <a :href="'mailto:' + config.EMAIL">{{ config.EMAIL }}</a><br />
            Det er svært viktig at du holder kontaktinfo under «Mine opplysninger» oppdatert, da det i verste fall kan gjøre at du mister et domenenavn hvis vi ikke får tak i deg pga feil kontaktinfo.<br />
            Du finner mer info om våre tjenester og avtalevilkår på <a :href="config.HOME_URL" target="_blank">{{ config.HOME_DOMAIN }}</a> og om Mekke Publisering (publiseringsverktøyet) på <a href="https://pub.mekke.no/" target="_blank">pub.mekke.no</a><br />
            Takk for at du bruker våre tjenester og gi oss gjerne en tilbakemelding hvis du har forslag til forbedringer!<br />
            <br />
            Vennlig hilsen<br />
            {{ config.OWNER_NAME }}<br />
            Daglig leder, {{ config.NAME }}
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="helpDialog.general = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpDialog.email" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Hjelp (e-post)
        </v-card-title>
        <v-card-text>
          <p>
            Her kan du opprette, endre eller slette dine epostkontoer og videresendinger.
          </p>
          <p>
            Noen nyttige linker:
          </p>
          <ul>
            <li>
              <a target="_blank" href="https://webmail.mekke.no/">Webmail</a>.
              Her kan du lese og sende e-post fra din e-postkonto. Fungerer overalt, innland eller utland, og på alle type enheter.
            </li>
            <li>
              <a target="_blank" href="https://mailadmin.mekke.no/">Mailadmin</a>.
              Her kan man administrere sin egen mailkonto. Endre passord, sette opp videresendinger eller autosvar/feriemelding.
            </li>
            <li>
              <a target="_blank" href="https://www.mekke.no/brukerhjelp-e-post-hjelp-8362s.html">Oppsett av mail</a>.
              Informasjon om hvordan du kan sette opp din enhet for å lese og sende epost fra din e-postkonto.
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="helpDialog.email = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpDialog.webhotel" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Hjelp (webhotell)
        </v-card-title>
        <v-card-text>
          <p>
            Her kan du finne FTP-informasjon, endre passord eller sette opp passordbeskyttelse for ditt webhotell.
          </p>
          <p>
          For å få tilgang til dine filer på webhotellet, må du logge inn med et ftp-program som må installeres lokalt f.eks. <a target="_target" href="https://filezilla-project.org/">FileZilla</a>.
          </p>
          <p>
            Hvis du har installert egen programvare har disse egen innlogging. Ta kontakt med oss hvis du ikke finner tilbake til den.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="helpDialog.webhotel = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpDialog.mekke" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Hjelp (mekke)
        </v-card-title>
        <v-card-text>
          <p>
            Her kan du se en oversikt over dine Mekke websider, og endre passord.
          </p>
          <p>
            Adminpanelet for din Mekke side finner du på <a target="_blank" href="https://admin.mekke.no/">admin.mekke.no</a>.
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="helpDialog.mekke = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpDialog.dns" max-width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Hjelp (domener)
        </v-card-title>
        <v-card-text>
          <p>
            Her kan du gjøre DNS-endringer på dine domener.
          </p>
          <p>Noen nyttige linker:</p>
          <ul>
            <li>
              <a target="_blank" href="https://www.norid.no/no/domeneoppslag/">Norid</a>.
              Gå hit for å dobbeltsjekke at info om ditt domenenavn er riktig.
            </li>
            <li>
              <a target="_blank" href="https://www.mekke.no/domene.php">Domeneregistrering</a>.
              Her kan du bestille nye domener.
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="helpDialog.dns = false">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import MyServicesService from '@/services/MyServicesService'

export default {
  name: 'my-services',
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      data: {
        initial: true,
        email: {},
        webhotel: {},
        mekke: {},
        domain: {}
      },
      helpDialog: {
        general: false,
        email: false,
        webhotel: false,
        mekke: false,
        dns: false
      }
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'my-services', MyServicesService.get)
      if (response) {
        this.data = response.data
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 340px !important;
  font-size: 1.2em;
}

.card .v-btn {
  font-size: 1em;
}
</style>
